import { render, staticRenderFns } from "./PublishButton.vue?vue&type=template&id=7332bc48&scoped=true"
import script from "./PublishButton.vue?vue&type=script&lang=js"
export * from "./PublishButton.vue?vue&type=script&lang=js"
import style0 from "./PublishButton.vue?vue&type=style&index=0&id=7332bc48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7332bc48",
  null
  
)

export default component.exports